import classnames from 'classnames';
import React from 'react';

interface Props {
	tittel?: string;
	className?: string;
	children: React.ReactNode;
}

function OppsummeringPunkt(props: Props) {
	const { tittel, children, className, ...rest } = props;
	const klasser = classnames('oppsummering-blokk-punkt', className);
	return (
		<div className={klasser} {...rest}>
			{!!tittel && <h4>{tittel}</h4>}
			{children}
		</div>
	);
}

export { OppsummeringPunkt };
